/**
 * A/B test variants for the Grit Mile landing page.
 *
 * 9 variants = 3 headline × 3 button label combinations.
 * Variant index is deterministically assigned per visitor via cookie hash.
 */

export type VariantId = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export type Variant = {
  readonly headline: string;
  readonly buttonLabel: string;
};

export const BRAND_TAG = "Grit is the mile after the wall." as const;

export const VARIANTS: ReadonlyArray<Variant> = [
  // Headline A × Button 1–3
  { headline: "Train harder. And smarter.", buttonLabel: "I'm in!" },
  { headline: "Train harder. And smarter.", buttonLabel: "Let's do this!" },
  { headline: "Train harder. And smarter.", buttonLabel: "Make me faster." },

  // Headline B × Button 1–3
  { headline: "Because average is for suckers.", buttonLabel: "I'm in!" },
  { headline: "Because average is for suckers.", buttonLabel: "Let's do this!" },
  { headline: "Because average is for suckers.", buttonLabel: "Make me faster." },

  // Headline C × Button 1–3
  { headline: "Stop training for participation trophies.", buttonLabel: "I'm in!" },
  { headline: "Stop training for participation trophies.", buttonLabel: "Let's do this!" },
  { headline: "Stop training for participation trophies.", buttonLabel: "Make me faster." },
] as const;
